var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBuyNowPayLater = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Time-Clock-File-Cash--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Time Clock File Cash Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 11a6.5 6.5 0 1 0 6.5 6.5A6.51 6.51 0 0 0 6.5 11Zm1 10.18c-0.1 0 -0.29 0.11 -0.29 0.29v0.28a0.75 0.75 0 0 1 -1.5 0v-0.25a0.25 0.25 0 0 0 -0.25 -0.25H5a0.75 0.75 0 0 1 0 -1.5h2a0.59 0.59 0 0 0 0.22 -1.14l-2.06 -0.83a2.08 2.08 0 0 1 0.34 -4 0.35 0.35 0 0 0 0.22 -0.33v-0.23a0.75 0.75 0 0 1 1.5 0v0.25a0.25 0.25 0 0 0 0.25 0.25H8a0.75 0.75 0 0 1 0 1.5H6a0.59 0.59 0 0 0 -0.59 0.59 0.58 0.58 0 0 0 0.37 0.55l2.06 0.83a2.09 2.09 0 0 1 -0.27 4Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.41 3 21 0.59A2 2 0 0 0 19.59 0H8a2 2 0 0 0 -2 2v7.28a0.26 0.26 0 0 0 0.24 0.25c0.37 0 1 0 1.49 0.08A0.25 0.25 0 0 0 8 9.36V2.25A0.25 0.25 0 0 1 8.25 2h11.23a0.29 0.29 0 0 1 0.18 0.07l2.27 2.27a0.29 0.29 0 0 1 0.07 0.18v13.73a0.25 0.25 0 0 1 -0.25 0.25h-7.11a0.25 0.25 0 0 0 -0.24 0.21 8.9 8.9 0 0 1 -0.4 1.46 0.24 0.24 0 0 0 0.23 0.33H22a2 2 0 0 0 2 -2V4.41A2 2 0 0 0 23.41 3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.25a4.75 4.75 0 1 0 -4.75 -4.75 4.75 4.75 0 0 0 4.75 4.75Zm0 -8a3.25 3.25 0 1 1 -3.25 3.25 3.26 3.26 0 0 1 3.25 -3.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.25h1.77a0.75 0.75 0 0 0 0 -1.5h-0.77a0.25 0.25 0 0 1 -0.25 -0.25v-0.77a0.75 0.75 0 0 0 -1.5 0V8.5a0.76 0.76 0 0 0 0.75 0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBuyNowPayLater);
export default ForwardRef;